import i18n from 'i18next';
import { reactI18nextModule } from 'react-i18next';
import studioEN from './en/studio.json';
import frontEN from './en/front.json';
import commonEN from './en/common.json';
import messageEN from './en/message.json';
import eventEN from './en/event.json';

import studioKO from './ko/studio.json';
import frontKO from './ko/front.json';
import commonKO from './ko/common.json';
import messageKO from './ko/message.json';
import eventKO from './ko/event.json';

i18n.use(reactI18nextModule).init({
  resources: {
    en: {
      studio: studioEN,
      front: frontEN,
      message: messageEN,
      common: commonEN,
      event: eventEN,
    },
    ko: {
      studio: studioKO,
      front: frontKO,
      message: messageKO,
      common: commonKO,
      event: eventKO,
    },
  },
  lng: 'en',
  fallbackLng: 'en',
  ns: ['front', 'studio', 'common', 'message', 'event'],
  defaultNS: 'common',
  debug: false,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n/index.js